import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const Audience = () => {
  const { t } = useLang();
  return (
    <section id="audience" className="py-24 lg:py-32 bg-[var(--ivory-2)]" data-testid="audience-section">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <span className="overline" data-testid="audience-overline">{t.audience.overline}</span>
          <h2 className="font-serif text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.08] tracking-tight text-[var(--navy)] mt-6" data-testid="audience-title">
            {t.audience.title}
          </h2>
          <div className="mt-8 w-14 h-px bg-[var(--champagne)]" />
          <p className="mt-8 text-[16px] lg:text-[17px] leading-[1.85] text-[var(--charcoal)]" data-testid="audience-intro">
            {t.audience.intro}
          </p>
        </motion.div>

        <motion.ul
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7 lg:pt-14 divide-y divide-[var(--border-light)] border-y border-[var(--border-light)]"
        >
          {t.audience.items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-5 py-5" data-testid={`audience-item-${idx}`}>
              <span className="overline w-10 shrink-0">{String(idx + 1).padStart(2, "0")}</span>
              <Check className="w-4 h-4 text-[var(--champagne)] shrink-0" strokeWidth={1.5} />
              <span className="font-serif text-[20px] lg:text-[24px] text-[var(--navy)] leading-tight">
                {item}
              </span>
            </li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default Audience;
